<app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
    [gridName]="gridName" [allowCopy]="true" (copyClicked)="copyUserClicked($event)"
    (refreshDataFromServer)="refreshData($event)" (rowSelected)="setUserData($event)"
    (viewAllClicked)="veiwAllUserData($event)" (addClicked)="addUserClicked()" (editClicked)="editUserClicked($event)"
    (deleteClicked)="deleteUserClicked()"></app-grid>